import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';

import { useApplicationContext } from '../../utils/withApplicationContext';
import { InfrastructureMicrofrontendContainer } from '../InfrastructureMicrofrontendContainer';
import { NearbyNewbuildingsLinkContainer } from '../NearbyNewbuildingsLink';
import { SpecialPromoLinkContainer } from '../SpecialPromoLink';

export const MapSelectorContainer: React.FC = () => {
  const { logger } = useApplicationContext();

  return (
    <ErrorLogComponent logger={logger}>
      <InfrastructureMicrofrontendContainer
        headerLinks={
          <>
            <SpecialPromoLinkContainer />
            <NearbyNewbuildingsLinkContainer />
          </>
        }
      />
    </ErrorLogComponent>
  );
};
